import LegalPage from "@/components/LegalPage";

const sections = [
  {
    heading: "1. Acceptance of These Terms",
    paragraphs: [
      "By accessing or using the BitGenix website, you agree to these Terms & Conditions. If you do not agree, you should stop using the website.",
    ],
  },
  {
    heading: "2. Website Purpose",
    paragraphs: [
      "The BitGenix website is intended to provide general information about our services, educational content, calculators, articles, and contact options. Nothing on the website is intended to create a client relationship automatically.",
    ],
  },
  {
    heading: "3. No Legal, Tax, Investment, or Financial Advice",
    paragraphs: [
      "Website content is provided for general informational and educational purposes only. It should not be treated as legal advice, tax advice, financial advice, investment advice, or a substitute for tailored professional guidance.",
      "Any reliance you place on blog content, calculators, examples, or website statements is at your own risk. Professional advice should be obtained before making legal, tax, investment, business, or compliance decisions.",
    ],
  },
  {
    heading: "4. No Client Relationship",
    paragraphs: [
      "Sending us a message, booking a discovery call, subscribing to updates, or browsing the website does not by itself create an advisor-client, consultant-client, lawyer-client, accountant-client, or fiduciary relationship. Any formal engagement must be agreed separately in writing.",
    ],
  },
  {
    heading: "5. Permitted Use",
    items: [
      "You may use the website for lawful, personal, or internal business purposes.",
      "You must not misuse the site, attempt unauthorized access, interfere with security, scrape protected systems, or use the website to transmit harmful code or spam.",
      "You must not copy, republish, or commercially exploit website content in a misleading way without permission.",
    ],
  },
  {
    heading: "6. Intellectual Property",
    paragraphs: [
      "Unless otherwise stated, website content including branding, copy, layout, graphics, articles, and other materials belongs to BitGenix or is used with permission. All rights are reserved.",
    ],
  },
  {
    heading: "7. Third-Party Links and Tools",
    paragraphs: [
      "The website may refer to third-party platforms, social channels, tools, or external websites. BitGenix is not responsible for third-party content, availability, or practices.",
    ],
  },
  {
    heading: "8. No Warranties",
    paragraphs: [
      "The website and its contents are provided on an \"as is\" and \"as available\" basis. We do not guarantee uninterrupted availability, error-free content, or that all information will remain complete, current, or suitable for every user or jurisdiction.",
    ],
  },
  {
    heading: "9. Limitation of Liability",
    paragraphs: [
      "To the maximum extent permitted by law, BitGenix will not be liable for indirect, incidental, consequential, special, or reliance-based losses arising from website use, inability to use the website, or reliance on website content.",
    ],
  },
  {
    heading: "10. Changes to the Website or Terms",
    paragraphs: [
      "We may update, suspend, or modify website content, functionality, or these Terms & Conditions at any time. The latest version published on this page will apply from its listed update date.",
    ],
  },
];

export default function TermsConditions() {
  return (
    <LegalPage
      title="Terms & Conditions"
      description="The rules governing access to and use of the BitGenix website."
      path="/terms-and-conditions"
      updatedAt="March 31, 2026"
      intro="These Terms & Conditions apply to your use of the BitGenix website, including its pages, articles, calculators, forms, and related content. They are intended as a general website-use framework and should be reviewed with legal counsel before final publication."
      sections={sections}
    />
  );
}
